import React, { PureComponent } from 'react';
import bindAll from 'lodash.bindall';
import event, { EVENTS } from '../../lib/event.js';
import styles from './style.css';
import ChatBtns from './chat-buttons';
import CloseBtn from './lesson_btn_close.png'


class ChatFooter extends PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            // 'onDrag',
            // 'handleStop',
            // 'showTips'
            'handleShowPhoneChat'
        ]);
    }

    // componentDidMount() {
    //     event.on('NO_TALK', this.noSpeak)
    //     event.on('SPEAKING', this.good)
    // }

    // componentWillReceiveProps(nextProps) {
    //     console.log(nextProps)
    // }

    handleShowPhoneChat(){
        event.emit(EVENTS.PHONE_CHATBOX);
        window.xiaoao('提示');
    }


    render() {
        const { btns, position, terminal,mode } = this.props
        return (
            <div className={`${styles.chatBtnBottom} ${terminal === 'pc' ? styles.white : ''}`} id='chatBottom'>
                {/* {terminal === 'phone' && <img onClick={()=>this.handleShowPhoneChat()} src={CloseBtn} className={styles.phoneCloseBtn}></img>} */}
                <ChatBtns cardButton={btns} btnType='yellow' position={position} mode={mode} />
            </div>
        );
    }
}

export default ChatFooter;
